export default __webpack_public_path__ + "static/media/starBucksCoupon.4e6f7e3c.png";